import classNames from 'classnames';
import { forwardRef } from 'react';

import Button from '~components/Button/Button';

import { BenefitData } from '../BenefitsExplorer';

import { mobileTile } from './MobileTile.module.css';

const MobileTile = forwardRef(function CreateMobileTile(
    { data }: { data: BenefitData },
    ref: React.ForwardedRef<HTMLDivElement | null>
) {
    return (
        <div
            ref={ref}
            data-page={data.page}
            className={classNames(
                'font-bold bg-white',
                'px-4',
                'snap-center',
                'flex-shrink-0 flex-grow-0',
                'flex flex-col items-center justify-between',
                mobileTile as string
            )}
        >
            <div className="flex flex-col items-center justify-center text-center">
                {data.icons[0]}
                <h3 className="text-24 leading-32 font-bold my-2 font-poppins">{data.heading}</h3>
                <p className="font-normal text-14">{data.bodyAlt}</p>
            </div>
            <Button
                islink
                forceATag
                href={process.env.GATSBY_EHMP_URL}
                data-filter={data.filter}
                styletype="primary"
                className="w-full font-poppins"
                data-wa-link={`Feature Benefits: ${data.name}: ${data.cta}`}
            >
                Compare plans
            </Button>
        </div>
    );
});

export default MobileTile;
